import { createSelector } from 'reselect';
import { MgState } from '@types';

export const selectAppLanguage = createSelector(
  (store: MgState) => store?.app,
  (app) => app.lang
);

export const appLoadingSelector = createSelector(
  (store: MgState) => store?.app,
  (app) => app.loading
);

export const barLoadingSelector = createSelector(
  (store: MgState) => store?.app,
  (app) => app.barLoading
);
